module.exports = __webpack_public_path__ + "static/media/radioButtonActive.0f4c3805.svg";